<template>
  <div>
    <search-profile-inventory-import-records @submit="submitSearch" />

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    >
      <div slot="operation_no" slot-scope="operation_no, record">
        <router-link :to="{ name: 'batch_operation_record_info', params: { id: record.id }}">
          {{ operation_no }}
        </router-link>
      </div>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findProfileInventoryImportRecords } from '@/api/profile_inventory'
import Pagination from '@/components/Pagination'
import SearchProfileInventoryImportRecords from '@/views/profile_inventories/import_records/Search'
import { formatFloat } from '@/utils/filter'

export default {
  name: 'ProfileInventoryImportRecords',
  components: {
    SearchProfileInventoryImportRecords,
    Pagination
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: { total_count: 0 },
      query: {},
      columns: [
        {
          title: '入库批次',
          dataIndex: 'operation_no',
          fixed: 'left',
          width: 120,
          scopedSlots: { customRender: 'operation_no' }
        },
        { title: '供应商', width: 140, dataIndex: 'profile_supplier_name' },
        { title: '入库成功数', width: 100, dataIndex: 'success_count' },
        {
          title: 'Profile费',
          width: 100,
          dataIndex: 'profile_fee',
          customRender: (t) => formatFloat(t)
        },
        {
          title: '总Profile费',
          width: 110,
          dataIndex: 'total_profile_fee',
          customRender: (t) => formatFloat(t)
        },
        { title: 'PRP规则', width: 160, dataIndex: 'prp_id_text' },
        { title: '状态', width: 100, dataIndex: 'profile_status_text' },
        { title: '批次状态', width: 100, dataIndex: 'status' },
        { title: '备注', width: 160, dataIndex: 'remark', ellipsis: true },
        { title: '入库时间', width: 170, dataIndex: 'created_at' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      findProfileInventoryImportRecords(this.query).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    }
  }
}
</script>
